// Both full and selected-line returns use the same persisted-result contract.
export function savedReturnId(body) {
    const result = body && body.results;
    const id = Number(result && result.data);
    const lines = result && result.DASF;
    const journal = result && result.ret;
    const journalWrites = Array.isArray(journal) && journal[0];
    const journalHeader = Array.isArray(journal) && journal[1] && journal[1].main;
    if (!body || !body.error || Number(body.error.number) !== 200 || !Number.isInteger(id) || id < 1 ||
        !result.in || !result.in.error || Number(result.in.error.number) !== 200 ||
        !Array.isArray(lines) || !lines.length || lines.some(line => !line.error || Number(line.error.number) !== 200) ||
        !Array.isArray(journalWrites) || !journalWrites.length ||
        journalWrites.some(write => !write.error || Number(write.error.number) !== 200) ||
        !journalHeader || Number(journalHeader.jvnom) < 1) {
        const error = new Error('return_save_failed');
        error.response = { data: body };
        throw error;
    }
    return id;
}

export function returnErrorMessage(error, arabic) {
    const code = error && error.response && error.response.data && error.response.data.error && error.response.data.error.code;
    if (code === 'return_accounts_not_ready') return arabic
        ? 'لم يتم حفظ المرتجع. يرجى استكمال ربط حسابات المرتجعات والضريبة وطريقة الدفع.'
        : 'Return was not saved. Check the return, tax and refund account mappings.';
    if (code === 'return_selection_invalid' || code === 'return_invoice_not_available') return arabic
        ? 'لم يتم حفظ المرتجع. حدّث الفاتورة وتحقق من الأصناف التي لم يتم إرجاعها.'
        : 'Return was not saved. Refresh the invoice and check which items are still available to return.';
    if (code === 'return_amounts_inconsistent') return arabic
        ? 'لم يتم حفظ المرتجع. إجماليات الفاتورة لا تطابق أصنافها وتحتاج إلى مراجعة.'
        : 'Return was not saved. The invoice totals and its lines need review.';
    if (code === 'return_refund_review_required') return arabic
        ? 'لم يتم حفظ المرتجع. تحتاج الدفعات المسجلة للفاتورة إلى مراجعة قبل صرف المبلغ.'
        : 'Return was not saved. Review the recorded invoice payments before issuing a refund.';
    if (code === 'return_stock_not_ready') return arabic
        ? 'لم يتم حفظ المرتجع. تحتاج حركة المخزون وتكلفة البيع الأصلية إلى مراجعة.'
        : 'Return was not saved. Review the original stock movement and sale-time cost.';
    return arabic
        ? 'تعذر تأكيد حفظ المرتجع. راجع قائمة المرتجعات قبل المحاولة مرة أخرى. تم الاحتفاظ بالبيانات المدخلة.'
        : 'Could not confirm the return was saved. Check the returns list before retrying. Your entered details have been kept.';
}
